var _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStaffLight(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    width: "800px",
    height: "800px",
    fill: "#fff",
    stroke: "#fff",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:none;stroke:#fff;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;} "), /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 10,
    className: "st0",
    width: 26,
    height: 16
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 11,
    cy: 16,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M7,22c0-2.2,1.8-4,4-4s4,1.8,4,4"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 19,
    y1: 16,
    x2: 25,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 22,
    y1: 20,
    x2: 25,
    y2: 20
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M20,10h-8V9c0-2.2,1.8-4,4-4h0c2.2,0,4,1.8,4,4V10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaffLight);
export default __webpack_public_path__ + "static/media/staff-light.d106956e5b4089b6d4256ee3eefd0d85.svg";
export { ForwardRef as ReactComponent };